import IqosphereApiManager from './api'

const api = new IqosphereApiManager()

export { api }
export { default as IqosphereApiManager } from './api'
export { default as IqosphereAnalytics } from './analytics'
